module.exports = __webpack_public_path__ + "img/speaker-MatthewJanney-imgs.75d26157.png";